// extracted by mini-css-extract-plugin
export var activityContainer = "_o6-0";
export var typingIndicatorContainer = "_o6-1";
export var typingIndicatorDot = "_o6-2";
export var wave = "_o6-3";